<!-- <app-loading *ngIf="!isPricingRoute"></app-loading> -->
<app-notification></app-notification>

<app-site-header *ngIf="!isDashboardRoute && !isPricingRoute && !isQrRoute"></app-site-header>
<router-outlet></router-outlet>

@defer (on viewport) {
  <app-site-footer *ngIf="!isDashboardRoute && !isPricingRoute && !isFaqRoute && !isContactRoute && !isQrRoute"></app-site-footer>
} @placeholder {
  <!-- Placeholder for site footer to avoid layout shift, maybe a simple div with min-height -->
  <div style="min-height: 100px;"></div>
}

@defer (on viewport) {
  <app-footer *ngIf="isPricingRoute || isFaqRoute || isContactRoute"></app-footer>
} @placeholder {
  <div style="min-height: 100px;"></div>
}

@defer (when isBottomBarVisible) {
  <app-fixed-bottom-bar
    *ngIf="isBottomBarVisible"
    (moreInfoClick)="onBottomBarMoreInfo()"
    (getStartedClick)="onBottomBarGetStarted()"
    (closeClick)="onBottomBarClose()">
  </app-fixed-bottom-bar>
}

@defer (when isRefundModalOpen) {
  <app-refund-modal
    [isOpen]="isRefundModalOpen"
    [hasBasketItems]="hasBasketItems"
    (closeModal)="closeRefundModal()"
    (buyNowClick)="onBuyNowClick()">
  </app-refund-modal>
}

@defer (on timer(3s)) {
  <app-cookie-consent 
    *ngIf="isCookieConsentVisible && !isDashboardRoute && !isQrRoute"
    (manageCookiesClick)="onCookieConsentManage()"
    (acceptAllClick)="onCookieConsentAccept()"
    (closeClick)="onCookieConsentClose()">
  </app-cookie-consent>
}

